import { render, staticRenderFns } from "./AAsignacionCorporacionV2.vue?vue&type=template&id=4c57cebd&scoped=true"
import script from "./AAsignacionCorporacionV2.vue?vue&type=script&lang=js"
export * from "./AAsignacionCorporacionV2.vue?vue&type=script&lang=js"
import style0 from "./AAsignacionCorporacionV2.vue?vue&type=style&index=0&id=4c57cebd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c57cebd",
  null
  
)

export default component.exports